import axios from "axios";

export const sendLoginInvite = (
  email: string,
  name: string,
  type: string,
  password?: string,
  role?: string
): any => {
  axios({
    method: "post",
    url: `${process.env.REACT_APP_FUNCTIONS_BASE_URL}email-signIn`,
    headers: { "Content-Type": "application/json" },
    data: {
      email: email,
      name: name,
      type: type,
      password: password,
      role: role,
    },
  })
    .then((response: any) => {
      // ("success");
      return response;
    })
    .catch((error: any) => {
      // (error);
    });
};
